module.exports = __webpack_public_path__ + "37dfe1ba6ff0f0d5dac13047fd1a8a1c.png";